export default __webpack_public_path__ + "static/media/driver.225b50a8.jpg";